import { API_URL } from 'env';

const API_ENDPOINT = API_URL;

const FileUploadService = {
  sendPost: (endpoint, fileList) => fetch(endpoint, {
    method: 'POST',
    credentials: 'include',
    body: fileList,
  }),
  getDocById: docId => fetch(`${API_ENDPOINT}/download-document/${docId}`, {
    method: 'GET',
    credentials: 'include',
  }),
};

export default FileUploadService;
